export const safariVersionIsAtLeast = (majorMinRequired, minorMinRequired) => {
    const ua = navigator.userAgent;
    // 1) Ensure it’s Safari (contains “Safari” but not “Chrome”/“CriOS”/“Android”)
    if (!/Safari/.test(ua) || /Chrome|CriOS|Android/.test(ua)) {
      return false;
    }
    // 2) Extract “Version/M.N”
    const match = ua.match(/Version\/(\d+)\.(\d+)/);
    if (!match) {
      return false;
    }
    const major = parseInt(match[1], 10);
    const minor = parseInt(match[2], 10);
    // 3) Compare (major, minor) ≥ (majorMinRequired, minorMinRequired)
    if (major > majorMinRequired) return true;
    if (major < majorMinRequired) return false;
    return minor >= minorMinRequired;
}

export const isCloverApplePaySupported = () => {
    // Required: supported browsers (Safari version 17.5 or above) and Apple Pay (v3) supported devices
    // https://docs.clover.com/dev/docs/clover-iframe-features-apple-pay
    try {
        return typeof window.ApplePaySession !== "undefined" 
        && window.ApplePaySession?.supportsVersion(3) 
        && window.ApplePaySession?.canMakePayments() 
        && safariVersionIsAtLeast(17, 5);
    } catch (e) {
        console.log("Error checking Clover Apple Pay support:", e);
        return false;
    }
}

// refer: https://docs.clover.com/dev/docs/initiate-3ds-sdk-with-create-a-charge-endpoint
export const handleClover3dsValidationResult = (threedsResult) => {
    if (window._3DSUtil === undefined) {
        console.error("Clover 3DS Util is not initialized.");
        return;
    }

    const validationResult = threedsResult?.validation_result;
    if (validationResult === "AUTHENTICATION_SUCCESSFUL") {
        // Do nothing, as the authentication is successful
    } else if (validationResult === "THREEDS_METHOD_FLOW_REQUIRED") {
        const threedsData = threedsResult?.data;
        const threeDSServerTransID = threedsData?.threeds_server_transaction_id;
        const threeDSMethodUrl = threedsData?.method_url;
        const methodNotificationUrl = threedsData?.method_notification_url;
        window._3DSUtil.perform3DSFingerPrinting({
            threeDSServerTransID,  
            threeDSMethodUrl,  
            methodNotificationUrl, 
        });
    } else if(validationResult === "CHALLENGE_FLOW_REQUIRED") {
        const threedsData = threedsResult?.data;
        const messageVersion = threedsData?.threeds_protocol_version;
        const acsTransID = threedsData?.acs_transaction_id;
        const acsUrl = threedsData?.acs_url;
        const threeDSServerTransID = threedsData?.threeds_server_transaction_id;
        window._3DSUtil.perform3DSChallenge({  
            messageVersion,  
            acsTransID,  
            acsUrl,  
            threeDSServerTransID  
        });
    }
}